export default __webpack_public_path__ + "static/media/4.decd0e96.mp4";